module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "favorites-container"
  }, [_c('div', {
    staticClass: "wrapper-btn-back",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [_c('button', {
    staticClass: "profile-orders-back",
    on: {
      "click": function($event) {
        _vm.$emit('close-modal')
      }
    }
  }, [_c('img', {
    staticClass: "arrow-back",
    attrs: {
      "src": "/static/img/arrow-back.svg",
      "alt": "ir hacia atras"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bold txt-center title-btn"
  }, [_vm._v("MIS FAVORITOS")])]), _vm._v(" "), _c('div', {
    staticClass: "favorites-title mb-2 title-bold uppercase",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("MIS favoritos")]), _vm._v(" "), _c('section', {
    staticClass: "favotite-table"
  }, [_c('std-table', {
    attrs: {
      "columns": _vm.headers,
      "rows": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('td', [_c('div', {
          staticClass: "product-info",
          on: {
            "click": function($event) {
              _vm.goTo(row)
            }
          }
        }, [_c('div', {
          staticClass: "img-container"
        }, [_c('img', {
          staticClass: "img-product",
          attrs: {
            "src": row.urlImage,
            "alt": "imagen del producto"
          }
        })]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_c('i', [_vm._v(_vm._s(row.name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.description))])])])]), _vm._v(" "), _c('td', {
          staticClass: "txt-center"
        }, [_vm._v(_vm._s(row.priceDiscount))]), _vm._v(" "), _c('td', {
          staticClass: "d-flex align-center justify-center"
        }, [_c('button', {
          staticClass: "btn-close",
          style: (("border: 0.1rem solid " + (_vm.globalColors.titulo))),
          on: {
            "click": function($event) {
              _vm.notFavorite(row)
            }
          }
        }, [_vm._v("X")])])]
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf11ec88","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/favorite/list.vue
// module id = 1159
// module chunks = 13